import type { FaireThemeEntity } from "../../entity_types/theme";

export const arkansas_game_day_rituals: FaireThemeEntity = {
  token: "arkansas-game-day-rituals",
  type: "theme",
  name: "Arkansas Game Day Rituals",
  description: "Celebrate local pride with officially licensed Razorback accessories and Natural State apparel designed for the Fayetteville fan base.",
  teaser: "Fayetteville pride -- Razorback accessories your customers are already looking for.",
  detail: "You're perfectly positioned to serve the University of Arkansas community. This theme leverages your success in selling regional graphic apparel and pop-up style accessories, built around the Razorback products already in your open cart.",
  bgColor: "#F5E6C8",
  tileBgColor: "#9e2d2d",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_vqdhuyqq88",
    "p_45mt9pkb86",
    "p_m47ktwazvd",
    "p_uf2qwg9hza",
    "p_e6k3chh4qx",
    "p_zz6bmwxhng",
    "p_5mgged7qpz",
    "p_rs8jx57yku",
    "p_2sdcb4vgn4",
    "p_fva7rcfv9t",
    "p_5h5ywaxuye",
    "p_jvdvzeuj9e",
    "p_t97gbcf7qk",
    "p_4evbh2u986",
    "p_423xxf5825",
    "p_yrywfwvtcd",
    "p_rz3n2dckvs",
    "p_z3em5g485b",
    "p_dpj5vz3ueg",
    "p_bh242x6cht",
    "p_7ejtxs2z3k",
    "p_8sjk9zk8yp",
    "p_yxsyqpsrn8",
    "p_mmcbhxghnx",
    "p_asf6zq38pw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "notion-v2-import",
  },
};
